<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <v-card class="card-body">
        <v-container>
          <h5>Neue Organisation</h5>
          <hr>

          <!-- Abkürzung-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Abkürzung</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.shortname"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.shortname"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.shortname"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>

          <!-- Name-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Name</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.name"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.name"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.name"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>

          <!-- Name2-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Name 2</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.name2"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.name2"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.name2"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>

          <!-- Adresse-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Adresse </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="organisationsObject.address"
                label="Adresse"
              />
            </div>
          </b-row>

          <!-- Postfach-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Postfach </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="organisationsObject.poBox"
                label="Postfach"
              />
            </div>
          </b-row>

          <!-- PLZ/ Ort-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> PLZ / Ort </label>
            <div class="col-2 pl-1">
              <v-text-field
                v-model="organisationsObject.zipCode"
                label="PLZ"
              />
            </div>
            <div class="col-5 pl-1">
              <v-text-field
                v-model="organisationsObject.city"
                label="Ort"
              />
            </div>
          </b-row>

          <!-- Telefon-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Telefon </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="organisationsObject.phone"
                label="Telefon"
              />
            </div>
          </b-row>

          <!-- Email-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Email </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="organisationsObject.email"
                label="Email"
              />
            </div>
          </b-row>

          <!-- Region/Sektion-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Region/Sektion</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.RegionSection"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.RegionSection"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.RegionSection"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>

          <!-- Homepage-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Homepage</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.Homepage"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.Homepage"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.Homepage"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>
        </v-container>
      </v-card>

      <v-btn
        :disabled="
          !organisationContentsDe.name ||
            !organisationContentsFr.name ||
            !organisationContentsFr.name
        "
        class="btn-left"
        color="success"
        raised
        title="Kontakt Erfassen"
        @click="createNew"
      >
        <i class="fas fa-plus mr-3" /> Neu Erfassen
      </v-btn>

      <v-btn
        color="#e72b37"
        raised
        style="color: white"
        title="Erfassen Abbrechen"
        @click="cancelCreate"
      >
        <i class="fas fa-ban mr-3" /> Abbrechen
      </v-btn>
    </div>
  </div>
</template>

<script>
import { PostOrganisation } from "@/services/user.crm.service";

export default {
  data() {
    return {
      isLoading: false,
      organisationsObject: {
        Id: 0,
        Address: "",
        PoBox: "",
        ZipCode: "",
        City: "",
        Phone: "",
        Email: "",
        OrganisationContents: [],
      },
      organisationContentsDe: {
        Id: 0,
        OrganisationId: 0,
        Language: "de-CH",
        Shortname: "",
        Name: "",
        Name2: "",
        Homepage: "",
        RegionSection: "",
      },
      organisationContentsFr: {
        Id: 0,
        OrganisationId: 0,
        Language: "fr-CH",
        Shortname: "",
        Name: "",
        Name2: "",
        Homepage: "",
        RegionSection: "",
      },
      organisationContentsIt: {
        Id: 0,
        OrganisationId: 0,
        Language: "it-CH",
        Shortname: "",
        Name: "",
        Name2: "",
        Homepage: "",
        RegionSection: "",
      },
      errorObject: null,
    };
  },
  created() {},
  methods: {
    routePage() {
      this.$router.push({
        path: "/organisation",
      });
    },
    cancelCreate() {
      this.routePage();
    },
    createNew() {
      this.isLoading = true;

      this.organisationsObject.OrganisationContents.push(
        this.organisationContentsDe,
      );
      this.organisationsObject.OrganisationContents.push(
        this.organisationContentsFr,
      );
      this.organisationsObject.OrganisationContents.push(
        this.organisationContentsIt,
      );
      PostOrganisation(
        this.organisationsObject,
        () => {
          this.isLoading = false;

          this.routePage();
        },
        (error) => {
          this.isLoading = false;

          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style scoped>
.card-body {
  margin: 20px;
}

.btn-left {
  margin-left: 20px;
}
</style>
